import { useState } from 'react';
import { cn } from '../../utils/cn';

interface InvestorCardProps {
  name: string;
  role?: string;
  description?: string;
  photo: string;
  isSelected?: boolean;
  onClick?: () => void;
  matchPercentage?: number;
  rank?: number;
}

export function InvestorCard({
  name,
  role,
  description,
  photo,
  isSelected = false,
  onClick,
  matchPercentage,
  rank,
}: InvestorCardProps) {
  const [imageError, setImageError] = useState(false);

  return (
    <button
      onClick={onClick}
      className={cn(
        'relative p-6 rounded-xl border text-left w-full bg-white',
        isSelected
          ? 'border-[#291B4C] shadow-lg'
          : 'border-[#291B4C]/10 hover:border-[#291B4C]/30'
      )}
    >
      {rank && (
        <div className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-[#291B4C] flex items-center justify-center text-white font-bold text-base shadow-lg border-4 border-white">
          {rank}
        </div>
      )}

      <div className="flex flex-col items-center text-center space-y-4">
        <div className={cn(
          'w-20 h-20 rounded-full overflow-hidden bg-[#291B4C]/5',
          'ring-2',
          isSelected ? 'ring-[#291B4C]' : 'ring-[#291B4C]/20'
        )}>
          {!imageError ? (
            <img
              src={photo}
              alt={name}
              className="w-full h-full object-cover"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-2xl font-bold text-[#291B4C]">
              {name.charAt(0)}
            </div>
          )}
        </div>

        <div>
          <h3 className="text-base font-bold text-[#291B4C] uppercase tracking-wide mb-1">
            {name}
          </h3>
          {role && (
            <p className="text-xs text-[#291B4C]/60 font-medium tracking-wide">
              {role}
            </p>
          )}
        </div>

        {description && (
          <p className="text-xs text-[#291B4C]/60 line-clamp-2 leading-relaxed">
            {description}
          </p>
        )}

        {matchPercentage !== undefined && (
          <div className="w-full space-y-2 pt-2 border-t border-[#291B4C]/10">
            <div className="flex items-baseline justify-between">
              <span className="text-xs font-semibold text-[#291B4C]/50 uppercase tracking-widest">
                Match
              </span>
              <span className="text-2xl font-bold text-[#291B4C] tabular-nums">
                {matchPercentage.toFixed(0)}%
              </span>
            </div>
            <div className="h-2 bg-[#291B4C]/5 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#291B4C] rounded-full"
                style={{ width: `${matchPercentage}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </button>
  );
}
